import React, { Component } from 'react'
import { get } from 'lodash'
import { makeStyles, } from "@material-ui/core"

const useStyles = makeStyles({
    container: {
        color: "red"
    },
})

export const GeneralFormErrors = ({ renderError, formProps }) => {

    const classes = useStyles()
    const name = "non_field_errors"
    const { formState: { errors } } = formProps
    const error = get(errors, name)
    if ( ! error ) {
        return null
    }

    return (
        <div className={classes.container}>
          {renderError ? renderError() : error.message}
        </div>
    )
}
